import PropTypes from 'prop-types'
import { useHistory, useParams } from 'react-router'
import { ConfirmationAlert } from 'ui-components-web'
import useAlert from '../hooks/useAlert'
import { handleFeedback } from '../util/video'
import { usePreventBack } from 'hooks/usePreventBack'

const withNoBack = (WrappedComponent) => {
  const Comp = function HOC(props) {
    const history = useHistory()
    const { memberId, pendingVisitId } = useParams()
    const { alert, setAlert, resetAlert } = useAlert()

    const showAlertEndCall = () => {
      const showFeedback = () => {
        handleFeedback(memberId, pendingVisitId, history)
      }
      setAlert({
        type: 'custom',
        visible: true,
        body: 'Are you sure you want to end this visit?',
        onYes: showFeedback,
        onNo: resetAlert,
        yesContent: 'END VISIT',
        noContent: 'CANCEL',
        yesAriaLabel: 'End visit and return home',
        noAriaLabel: 'Return to visit',
        customYesBtnClass: 'alert-link-yes alert-link',
        customNoBtnClass: 'alert-link-no alert-link',
      })
    }

    usePreventBack(showAlertEndCall)

    return (
      <>
        <ConfirmationAlert {...alert} />
        <WrappedComponent {...props} />
      </>
    )
  }

  Comp.propTypes = {
    location: PropTypes.object,
  }
  return Comp
}

export default withNoBack
